import React from 'react';
import PropTypes, { shape } from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';

const { pathname } = window.location;
const paths = pathname.split('/');
const linktype = paths[3];

function FeeInfo({ fees }) {
  const filteredFees = fees.filter(
    (fee) => fee && fee.name && fee.name.trim().toLowerCase() !== 'iof',
  );

  if (fees.length === 0) {
    return (
      <>
        <h6>Outras despesas:</h6>
        <Skeleton width="50%" />
      </>
    );
  }

  if (filteredFees.length === 0) {
    return null;
  }

  return (
    <>
      <h6>
        Outras despesas:
      </h6>
      <ul>
        { filteredFees.map(({
          name: feeName, currencyCode, totalValue, valueWithoutSR,
        }) => (
          <li key={feeName}>
            {`${feeName}`}
            {(linktype !== '2') && (
            <>
              {valueWithoutSR && valueWithoutSR > totalValue && (
              <>
                :&nbsp; de &nbsp;
                <span
                  className="text-decoration-line-through text-danger"
                >
                  {`${formatPrice(valueWithoutSR, currencyCode)}`}
                </span>
                &nbsp; por &nbsp;
              </>
              )}
              <span className="blue">
                :&nbsp;
                {`${formatPrice(totalValue, currencyCode)}`}
                {valueWithoutSR && valueWithoutSR > totalValue && (
                <>
                &nbsp; (
                  <span
                    className="blue"
                  >
                    {`${(((valueWithoutSR - totalValue) / valueWithoutSR) * 100).toFixed(0)}`}
                  </span>
                  %&nbsp;de desconto)
                </>
                )}
              </span>
            </>
            )}
          </li>
        )) }
      </ul>
    </>
  );
}

FeeInfo.propTypes = {
  fees: PropTypes.arrayOf(
    shape({
      name: PropTypes.string,
      payment: shape({
        currency: PropTypes.string,
        value: PropTypes.number,
      }),
    }),
  ).isRequired,
};

export default FeeInfo;
